import React, { FC, ReactNode } from 'react'
import { observer } from 'mobx-react'
import './index.scss'

// interface
interface IProps {
}

const PageLoading: FC<IProps> = () => {
  return (
    <div
      className='ddloading-wrap page-loading'
    >
      <img src={window.BASECONFIG?.loadingGif} />
    </div>
  )
}

export default observer(PageLoading)
